export default __webpack_public_path__ + "static/media/21.d0a5ccb3.jpg";